import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from '@/shared-components/icons/components/public/XIcon';

import { RESALE_OPTION_CONFIG } from './purchaseFooter.constants';

export function ResaleOptionsPopupContent({
  selectedOption,
  onOptionChange,
  onSubmit,
  onClose,
  error,
  saving,
}) {
  return (
    <>
      <div className="purchase-footer__popup-header">
        <div className="purchase-footer__popup-header-top">
          <h3>Secondary-market options</h3>
          <XIcon
            className="purchase-footer__popup-close"
            onClick={onClose}
          />
        </div>
        <p>Choose how collectors can approach this artwork in your collection.</p>
      </div>

      <div className="purchase-footer__options-list">
        {RESALE_OPTION_CONFIG.map(({ value, label, description }) => (
          <label
            key={value}
            className={`purchase-footer__option ${value === selectedOption ? 'active' : ''}`}
          >
            <input
              type="radio"
              name="resale-option"
              value={value}
              checked={value === selectedOption}
              onChange={() => onOptionChange(value)}
              disabled={saving}
            />
            <div className="purchase-footer__option__body">
              <span className="purchase-footer__option__label">{label}</span>
              <span className="purchase-footer__option__description">{description}</span>
            </div>
          </label>
        ))}
      </div>

      {error && (
        <p className="purchase-footer__error">{error}</p>
      )}

      <div className="purchase-footer__popup-actions">
        <ContinueButton
          onClick={onSubmit}
          className="purchase-footer__popup-action"
          loading={saving}
          turnOff={saving}
          continueClass={false}
        >
          Save preference
        </ContinueButton>
      </div>
    </>
  );
}

export function ResaleOfferPopupContent({
  displayCurrency,
  enforceHigherOffer,
  effectiveLastSalePriceFormatted,
  offerAmount,
  onAmountChange,
  onSubmit,
  onClose,
  submitting,
  error,
}) {
  return (
    <>
      <div className="purchase-footer__popup-header">
        <div className="purchase-footer__popup-header-top">
          <h3>Make an offer</h3>
          <XIcon
            className="purchase-footer__popup-close"
            onClick={onClose}
          />
        </div>
        <p>
          {enforceHigherOffer && effectiveLastSalePriceFormatted
            ? `Offers must exceed ${effectiveLastSalePriceFormatted}.`
            : 'Name your price. The owner will review your offer.'}
        </p>
      </div>

      {effectiveLastSalePriceFormatted && (
        <div className="purchase-footer__offer-summary">
          <span className="purchase-footer__offer-summary-label">Last sale</span>
          <span className="purchase-footer__offer-summary-value">
            {effectiveLastSalePriceFormatted}
          </span>
        </div>
      )}

      <form className="purchase-footer__offer-form" onSubmit={(event) => {
        event.preventDefault();
        onSubmit();
      }}>
        <label className="purchase-footer__offer-input-label" htmlFor="offer-amount">
          Offer amount
        </label>
        <div className="purchase-footer__offer-input-wrapper">
          {displayCurrency && (
            <span className="purchase-footer__offer-currency">{displayCurrency}</span>
          )}
          <input
            id="offer-amount"
            className="purchase-footer__offer-input"
            type="number"
            min="0"
            step="0.01"
            value={offerAmount}
            onChange={(event) => onAmountChange(event.target.value)}
            disabled={submitting}
            placeholder="Enter amount"
          />
        </div>

        {error && (
          <p className="purchase-footer__error">{error}</p>
        )}

        <div className="purchase-footer__popup-actions">
          <ContinueButton
            className="purchase-footer__popup-action"
            type="submit"
            loading={submitting}
            turnOff={submitting}
            continueClass={false}
          >
            Confirm offer
          </ContinueButton>
        </div>
      </form>
    </>
  );
}
